module.exports = __webpack_public_path__ + "img/background_main.5a716477.jpg";